import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { notification } from 'antd';

import RuleDetailsContext from '@totem/components/rulesEngine/details/ruleDetailsContext';
import { Rule } from '@totem/components/rulesEngine/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { RULES_ENDPOINT } from '@totem/utilities/endpoints';
import {
  CheckResponse,
  CheckResponseShowError,
} from '@totem/utilities/responseUtilities';

type Props = {
  children?: ReactNode;
};

const RuleDetailsContainer = ({ children }: Props) => {
  const { id } = useParams<{ id: string }>();
  const { getApiToken } = useContext(UserProfileContext);
  const [rule, setRule] = useState<Rule | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [notFound, setNotFound] = useState<boolean>(false);

  const refresh = () => {
    if (!id) {
      setLoading(false);

      setNotFound(true);

      return;
    }

    setLoading(true);

    setNotFound(false);

    fetch(`${RULES_ENDPOINT}${id}`, {
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => CheckResponse(res))
      .then((res) => {
        if (res.status === 404) {
          setNotFound(true);

          return null;
        }
        if (!CheckResponseShowError(res)) {
          return null;
        }
        return res.json();
      })
      .then((result: Rule | null) => {
        if (result) setRule(result);
      })
      .catch(() => {
        notification.error({ message: 'Failed to load rule.' });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    refresh();
  }, [id, getApiToken]);

  return (
    <RuleDetailsContext.Provider
      value={{ rule, loading, notFound, onRefresh: refresh }}
    >
      {children}
    </RuleDetailsContext.Provider>
  );
};

export default RuleDetailsContainer;
